import { parseISO } from 'date-fns';
import { useMemo } from 'react';

import { useApiData } from './useApiData';

export const getHolidayLabel = (holiday: Holiday): string =>
  holiday.override_summary ?? (holiday.summary || 'Company holiday');

function useFetchHolidays() {
  const { data: computedHolidays, refresh } = useApiData<Holiday[]>((api) =>
    api.company.getComputedCompanyHolidays()
  );

  const holidays = useMemo(
    () =>
      [...(computedHolidays ?? [])].sort(
        (a, b) =>
          parseISO(a.start_date).getTime() - parseISO(b.start_date).getTime()
      ),
    [computedHolidays]
  );

  return { holidays, refresh };
}

export default useFetchHolidays;
